import { render } from "./foot.vue?vue&type=template&id=789c14e3"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=789c14e3&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__